import { useEffect, useState } from "react";

import { showToast } from "../../utils/hot-toast";

import ERC20Abi from "../../abis/ERC20.json";
import { MAX_UINT256 } from "../../utils/constants";
import { FiChevronsRight } from "react-icons/fi";

const PresaleDeposit = ({
    presaleContract,
    presaleAddress,
    tokenDetails,
    active,
    account,
}) => {
    const [allowance, setAllowance] = useState(0);
    const [depositedBalance, setDepositedBalance] = useState(0);

    const [tokensTotalNeeded, setTokensTotalNeeded] = useState(0);
    const [tokenContract, setTokenContract] = useState();
    useEffect(() => {
        if (active && account.length) {
            loadData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, account]);

    const loadData = async () => {
        const web3 = window.web3;

        const _tokenContract = new web3.eth.Contract(
            ERC20Abi.abi,
            tokenDetails.tokenAddress
        );

        // tokensForPresaleWithExtra
        const [_tokensTotalNeeded, _decimals, _allowance, _depositedBalance] =
            await Promise.all([
                presaleContract.methods.tokensTotalNeeded().call(),
                _tokenContract.methods.decimals().call(),
                _tokenContract.methods
                    .allowance(account, presaleAddress)
                    .call(),
                _tokenContract.methods.balanceOf(presaleAddress).call(),
            ]);
        setTokenContract(_tokenContract);
        setTokensTotalNeeded((_tokensTotalNeeded / 10 ** _decimals).toFixed(0));
        setAllowance(parseInt(_allowance));
        setDepositedBalance(parseInt(_depositedBalance / 10 ** _decimals));
        console.log("depositedBalance", depositedBalance);
        // const
    };

    const approvePresale = async () => {
        try {
            await tokenContract.methods
                .approve(presaleAddress, MAX_UINT256)
                .send({ from: account });
            loadData();
            showToast(
                "SUCCESS",
                "You successfully apporved the contract, Deposit token to initiate your presale!"
            );
        } catch (error) {
            console.log(error);
            if (error.code === 4001) {
                showToast("ERROR", error.message);
                return;
            }
            showToast("ERROR", "Something went wrong!");
        }
    };

    const depositeToken = async () => {
        try {
            await presaleContract.methods
                .depositTokensForPresale()
                .send({ from: account });
            loadData();
            showToast("SUCCESS", "You successfully deposited the token!");
        } catch (error) {
            console.log(error);
            if (error.code === 4001) {
                showToast("ERROR", error.message);
                return;
            }
            showToast("ERROR", "Something went wrong!");
        }
    };
    return (
        <div className="component-container rounded-lg shadow-lg p-6 flex flex-col w-full">
            <span className="size-2 font-semibold">Deposit Presale Tokens</span>
            <div className="flex justify-between items-start flex-col">
                <span className="pt-4">
                    You need {tokensTotalNeeded}#
                    {tokenDetails.tokenArray[1].text} to deposit and complete
                    your presale
                </span>
                <span className="pb-1 text-buttonLightOrange dark:text-buttonDarkOrange">
                    Make sure fees are disabled before depositing tokens!
                </span>
                <div className="flex items-center w-full justify-center gap-4">
                    <button
                        disabled={allowance > tokensTotalNeeded}
                        className="blueGradient-button text-white font-normal"
                        onClick={approvePresale}
                    >
                        Approve
                    </button>
                    <FiChevronsRight className="size-2" />
                    <button
                        disabled={
                            allowance <= tokensTotalNeeded ||
                            depositedBalance >= tokensTotalNeeded
                        }
                        className="blueGradient-button text-white font-normal"
                        onClick={depositeToken}
                    >
                        Deposit
                    </button>
                </div>
            </div>
        </div>
    );
};
export default PresaleDeposit;
